// ── UI interactions ────────────────────────────────────
// ── UI interactions ───────────────────────────────────────────────────────────
function toggleSignIn() {
  document.getElementById('signinModal').classList.toggle('open');
}
function toggleSearch() {
  const overlay = document.getElementById('searchOverlay');
  overlay.classList.toggle('open');
  if (overlay.classList.contains('open')) {
    setTimeout(() => document.getElementById('searchInput').focus(), 50);
  }
}

function toggleMobileMenu() {
  document.getElementById('mobileMenu').classList.toggle('open');
}
// Close modal on overlay click
document.getElementById('signinModal').addEventListener('click', function(e) {
  if (e.target === this) toggleSignIn();
});
// Close search on Escape
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.getElementById('signinModal').classList.remove('open');
    document.getElementById('searchOverlay').classList.remove('open');
    document.getElementById('mobileMenu').classList.remove('open');
  }
});

// ── Product tab switcher ──────────────────────────────────────────────────────
function switchTab(event, tabId) {
  // Deactivate all tabs and panels
  document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
  document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
  // Activate clicked
  event.currentTarget.classList.add('active');
  document.getElementById(tabId).classList.add('active');
}


// ── Accordion toggle ──────────────────────────────────────────────────────────
function toggleAccordion(header) {
  const body = header.nextElementSibling;
  const icon = header.querySelector('.accordion-icon');
  const isOpen = body.classList.contains('open');
  // Close all
  document.querySelectorAll('.accordion-body').forEach(b => b.classList.remove('open'));
  document.querySelectorAll('.accordion-icon').forEach(i => i.classList.remove('open'));
  // Open clicked if it was closed
  if (!isOpen) {
    body.classList.add('open');
    icon.classList.add('open');
  }
}

// ── Cart badge counter ────────────────────────────────────────────────────────
let cartCount = 0;
function toggleCart() {
  cartCount++;
  document.querySelector('.cart-badge').textContent = cartCount;
  alert('Item added to cart! (Cart connects to Shopify on migration)');
}


// ── Compare toggle (Mix vs Separated) ─────────────────────────────────────────
let compareShowingSeparated = false;
function toggleCompare() {
  compareShowingSeparated = !compareShowingSeparated;
  const knob = document.getElementById('toggle-knob');
  const labelMix = document.getElementById('toggle-label-mix');
  const labelSep = document.getElementById('toggle-label-sep');
  const cardBad = document.getElementById('card-bad');
  const cardGood = document.getElementById('card-good');
  if (compareShowingSeparated) {
    knob.style.transform = 'translateX(28px)';
    labelMix.style.opacity = '0.4';
    labelSep.style.opacity = '1';
    cardBad.classList.add('dimmed');
    cardGood.classList.add('highlighted');
    cardGood.classList.remove('dimmed');
    cardBad.classList.remove('highlighted');
  } else {
    knob.style.transform = 'translateX(0)';
    labelMix.style.opacity = '1';
    labelSep.style.opacity = '0.5';
    cardBad.classList.remove('dimmed');
    cardGood.classList.remove('highlighted');
  }
}

// ── Reveal compare items on scroll ────────────────────────────────────────────
(function() {
  const revealItems = () => {
    document.querySelectorAll('.compare-item').forEach((el, i) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight - 60) {
        setTimeout(() => el.classList.add('revealed'), i * 80);
      }
    });
  };
  window.addEventListener('scroll', revealItems, { passive: true });
  revealItems(); // run on load too
})();

// ── Animations ──────────────────────────────────────
// ── Bottle spin: wild movement, stops upright every 7s ───────────────────────
(function() {
  const bottle = document.querySelector('.hero-image img');
  if (!bottle) return;

  let angle = 0;
  let velocity = 1.2;
  let targetVelocity = 1.2;
  let direction = 1;
  let paused = false;
  let lastTime = null;
  let changeTimer = 0;
  let isDragging = false;
  let dragStartX = 0;
  let dragLastAngle = 0;
  let uprightTimer = 0;
  let returningToUpright = false;
  let uprightPause = 0;
  const UPRIGHT_INTERVAL = 4000; // every 4 seconds
  const UPRIGHT_HOLD = 1000;     // hold upright for 1 second

  function randomizeBehavior() {
    targetVelocity = 0.3 + Math.random() * 4.2;
    if (Math.random() < 0.3) direction *= -1;
    paused = Math.random() < 0.1;
    changeTimer = 1200 + Math.random() * 3300;
  }

  randomizeBehavior();
  let elapsed = 0;

  function animate(ts) {
    if (!lastTime) lastTime = ts;
    const dt = Math.min(ts - lastTime, 50);
    lastTime = ts;

    elapsed += dt;
    uprightTimer += dt;

    // Every 7 seconds: smoothly return to 0° and hold
    if (uprightTimer >= UPRIGHT_INTERVAL && !returningToUpright && !isDragging) {
      returningToUpright = true;
      uprightPause = 0;
      velocity = 0;
      targetVelocity = 0;
    }

    if (returningToUpright) {
      // Normalize angle to nearest 0 (or 360)
      let normalized = angle % 360;
      if (normalized > 180) normalized -= 360;
      if (normalized < -180) normalized += 360;
      // Ease toward 0
      angle -= normalized * 0.12;
      if (Math.abs(normalized) < 0.5) {
        angle = Math.round(angle / 360) * 360;
        uprightPause += dt;
        if (uprightPause >= UPRIGHT_HOLD) {
          returningToUpright = false;
          uprightTimer = 0;
          elapsed = 0;
          randomizeBehavior();
        }
      }
    } else {
      if (elapsed >= changeTimer) {
        elapsed = 0;
        randomizeBehavior();
      }
      velocity += (targetVelocity - velocity) * 0.04;
      if (!paused && !isDragging) {
        angle += direction * velocity * (dt / 16);
      }
    }

    bottle.style.transform = `rotate(${angle}deg)`;
    requestAnimationFrame(animate);
  }
  requestAnimationFrame(animate);

  // Drag to spin
  bottle.addEventListener('mousedown', e => {
    isDragging = true;
    dragStartX = e.clientX;
    dragLastAngle = angle;
    bottle.style.cursor = 'grabbing';
    e.preventDefault();
  });
  window.addEventListener('mousemove', e => {
    if (!isDragging) return;
    const dx = e.clientX - dragStartX;
    angle = dragLastAngle + dx * 0.8;
    velocity = 0;
  });
  window.addEventListener('mouseup', () => {
    if (isDragging) {
      isDragging = false;
      bottle.style.cursor = 'grab';
      targetVelocity = 2 + Math.random() * 3;
      returningToUpright = false;
    }
  });

  // Click to burst spin
  bottle.addEventListener('click', () => {
    if (!isDragging) {
      targetVelocity = 15 + Math.random() * 10;
      direction = Math.random() < 0.5 ? 1 : -1;
      returningToUpright = false;
      uprightTimer = 0;
      setTimeout(() => { targetVelocity = 1 + Math.random() * 2; }, 800);
    }
  });

  // Hover to slow/highlight
  bottle.addEventListener('mouseenter', () => {
    if (!isDragging && !returningToUpright) targetVelocity = 0.4;
  });
  bottle.addEventListener('mouseleave', () => {
    if (!isDragging && !returningToUpright) targetVelocity = 1.2 + Math.random() * 2;
  });
})();

// ── Magnetic cursor on CTA buttons ───────────────────────────────────────────
(function() {
  document.querySelectorAll('.btn-primary, .btn-buy, .nav-cta').forEach(btn => {
    btn.style.transition = 'transform 0.2s cubic-bezier(0.23,1,0.32,1), background 0.2s';
    btn.style.display = 'inline-block';
    btn.addEventListener('mousemove', e => {
      const r = btn.getBoundingClientRect();
      const cx = r.left + r.width / 2;
      const cy = r.top + r.height / 2;
      const dx = (e.clientX - cx) * 0.35;
      const dy = (e.clientY - cy) * 0.35;
      btn.style.transform = `translate(${dx}px, ${dy}px) scale(1.06)`;
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.transform = 'translate(0,0) scale(1)';
    });
  });
})();

// ── Scroll-reveal: fade+slide sections into view ──────────────────────────────
(function() {
  const style = document.createElement('style');
  style.textContent = `
    .reveal { opacity: 0; transform: translateY(40px); transition: opacity 0.7s ease, transform 0.7s ease; }
    .reveal.visible { opacity: 1; transform: translateY(0); }
    .reveal-left { opacity: 0; transform: translateX(-40px); transition: opacity 0.7s ease, transform 0.7s ease; }
    .reveal-left.visible { opacity: 1; transform: translateX(0); }
    .reveal-right { opacity: 0; transform: translateX(40px); transition: opacity 0.7s ease, transform 0.7s ease; }
    .reveal-right.visible { opacity: 1; transform: translateX(0); }
  `;
  document.head.appendChild(style);

  // Tag elements
  document.querySelectorAll('.section-title, .section-sub, .section-eyebrow').forEach((el, i) => {
    el.classList.add('reveal');
    el.style.transitionDelay = (i % 3 * 0.12) + 's';
  });
  document.querySelectorAll('.ingredient-side.cleanser').forEach(el => el.classList.add('reveal-left'));
  document.querySelectorAll('.ingredient-side.nurturer').forEach(el => el.classList.add('reveal-right'));
  document.querySelectorAll('.usage-card, .faq-card, .product-card').forEach((el, i) => {
    el.classList.add('reveal');
    el.style.transitionDelay = (i * 0.1) + 's';
  });

  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => obs.observe(el));
})();

// ── Particle burst on hero CTA click ─────────────────────────────────────────
(function() {
  function burst(x, y) {
    const colors = ['#1B4F8C','#C79B45','#6EB4F7','#e8b85a','#ffffff'];
    for (let i = 0; i < 22; i++) {
      const p = document.createElement('div');
      const angle = (Math.PI * 2 * i) / 22 + Math.random() * 0.3;
      const speed = 80 + Math.random() * 120;
      const size = 4 + Math.random() * 6;
      p.style.cssText = `
        position:fixed; left:${x}px; top:${y}px;
        width:${size}px; height:${size}px;
        border-radius:50%;
        background:${colors[Math.floor(Math.random()*colors.length)]};
        pointer-events:none; z-index:9999;
        transition: transform 0.7s ease-out, opacity 0.7s ease-out;
        transform: translate(-50%,-50%);
      `;
      document.body.appendChild(p);
      requestAnimationFrame(() => {
        p.style.transform = `translate(calc(-50% + ${Math.cos(angle)*speed}px), calc(-50% + ${Math.sin(angle)*speed}px))`;
        p.style.opacity = '0';
      });
      setTimeout(() => p.remove(), 750);
    }
  }

  document.querySelectorAll('.btn-primary, .btn-buy').forEach(btn => {
    btn.addEventListener('click', e => burst(e.clientX, e.clientY));
  });
})();

// ── Nav logo scroll spin ──────────────────────────────────────────────────────
(function() {
  var logo = document.getElementById('nav-logo-img');
  var lastScroll = window.pageYOffset || 0;
  var angle = 0;
  window.addEventListener('scroll', function() {
    var current = window.pageYOffset || 0;
    var delta = current - lastScroll;
    angle += delta * 0.4;
    if (logo) logo.style.transform = 'rotate(' + angle + 'deg)';
    lastScroll = current;
  }, { passive: true });
})();